import {
  ActivationCreditStatus,
  DeviceStatus,
  SortOrder,
  TransactionStatus,
  TransactionType,
  TTransactionData,
  WithdrawalStatus,
} from "../types/types";

export const initPaginationData = {
  currentPage: 1,
  pageItems: 1,
  totalItems: 1,
  totalPages: 1,
  totalFilteredItems: 1,
};

//Dashboard page
//Dashboard page
//Dashboard page
export const dashboardColumns = [
  {
    title: "UNIQUE REFERENCE",
    dataIndex: "unique_reference",
    key: "unique_reference",
  },
  {
    title: "ACTION TYPE",
    dataIndex: "action_type",
    key: "action_type",
  },
  {
    title: "AMOUNT",
    dataIndex: "amount",
    key: "amount",
  },
  // {
  //   title: "CURRENCY",
  //   dataIndex: "currency",
  //   key: "currency",
  // },
  {
    title: "DATE",
    dataIndex: "date",
    key: "date",
  },
  {
    title: "STATUS",
    key: "status",
    dataIndex: "status",
  },
];

export const dashboardStatusOptions = [
  { field: "", value: "All" },
  { field: "status", value: WithdrawalStatus.SUCCESSFUL },
  { field: "status", value: WithdrawalStatus.PENDING },
  { field: "status", value: WithdrawalStatus.REFUNDED },
];

export const dashboardSortOptions = [
  { order: SortOrder.DESC, field: "createdAt", key: "1" },
  { order: SortOrder.ASC, field: "createdAt", key: "0" },
];

//device page
//device page
//device page
export const deviceTableColumns = [
  {
    title: "",
    dataIndex: "select",
    key: "select",
  },
  {
    title: "SERIAL NUMBER",
    dataIndex: "serialNumber",
    key: "serialNumber",
  },
  {
    title: "PAYMENT PLAN",
    dataIndex: "paymentPlan",
    key: "paymentPlan",
  },
  {
    title: "AMOUNT PAID",
    key: "amountPaid",
    dataIndex: "amountPaid",
  },
  {
    title: "TOTAL COST",
    key: "totalCost",
    dataIndex: "totalCost",
  },
  {
    title: "PAY GO MODE",
    dataIndex: "paygMode",
    key: "paygMode",
  },
  {
    title: "ACTIVE",
    dataIndex: "isActive",
    key: "isActive",
  },
  {
    title: "STATUS",
    dataIndex: "status",
    key: "status",
  },
];

export const deviceStatusOptions = [
  { field: "", value: "All" },
  { field: "status", value: DeviceStatus.PURCHASED },
  { field: "status", value: DeviceStatus.AVAILABLE },
];

export const deviceSortOptions = [
  { order: SortOrder.DESC, field: "createdAt", key: "1" },
  { order: SortOrder.ASC, field: "createdAt", key: "0" },
];

export const initialDeviceData = {
  __v: 0,
  _id: "",
  amountPaid: 0,
  count: 0,
  createdAt: new Date(),
  isActive: false,
  key: "",
  owner: "",
  paygMode: "",
  paymentPlan: {
    _id: "",
    planName: "",
    fullPaymentAmount: 0,
    noOfDevices: 0,
    paymentBonuses: [],
    paymentClauses: [],
  },
  activePaymentPlan: {
    _id: "",
    planName: "",
    fullPaymentAmount: 0,
    paymentBonuses: [],
    paymentClauses: [],
  },
  deviceModel: {
    _id: "",
    avgPrice: "",
    batteryCapacity: "",
    brand: {
      _id: "",
      brandId: "",
      brandName: "",
      brandLogo: "",
      contactDetails: {
        address: "",
        email: "",
        phoneNumber: "",
        website: "",
        _id: "",
      },
      country: "",
      createdAt: new Date(),
      paymentBonuses: new Date(),
    },
    description: "",
    deviceType: "",
    modelId: "",
    modelName: "",
    powerOutput: "",
    updatedAt: new Date(),
    createdAt: new Date(),
  },
  serialNumber: "",
  startingCode: "",
  status: "",
  totalCost: 0,
  updatedAt: new Date(),
  lastActivationDate: new Date(),
  nextExpirationDate: new Date(),
};

//customer page
//customer page
//customer page
export const customerTableColumns = [
  {
    title: "",
    dataIndex: "select",
    key: "select",
  },
  {
    title: "FULL NAME",
    dataIndex: "fullName",
    key: "fullName",
  },
  {
    title: "EMAIL",
    dataIndex: "email",
    key: "email",
  },
  {
    title: "COUNTRY",
    dataIndex: "country",
    key: "country",
  },
  {
    title: "NO OF DEVICES",
    key: "devices",
    dataIndex: "devices",
  },
];

export const costumerStatusOptions = [
  { field: "", value: "All" },
  { field: "status", value: "purchased" },
  { field: "status", value: "available" },
];

export const customerSortOptions = [
  { order: SortOrder.DESC, field: "createdAt", key: "1" },
  { order: SortOrder.ASC, field: "createdAt", key: "0" },
];

export const initCustomerData = {
  _id: "",
  address: "",
  avatar: "",
  country: "",
  createdAt: new Date(),
  customerId: "",
  devices: [],
  distributor: "",
  email: "",
  fullName: "",
  phone: "",
  referralCode: "",
  updatedAt: new Date(),
  wallet: "",
  __v: 0,
};

//transactions page
//transactions page
//transactions page
export const transactionColumns = [
  {
    title: "FULL NAME",
    dataIndex: "customerFullName",
    key: "customerFullName",
  },
  {
    title: "DEVICE",
    dataIndex: "device",
    key: "device",
  },
  {
    title: "AMOUNT",
    dataIndex: "transactionAmount",
    key: "amount",
  },
  {
    title: "TYPE",
    dataIndex: "transactionMode",
    key: "transactionMode",
  },
  {
    title: "DATE",
    key: "date",
    dataIndex: "date",
  },
  {
    title: "STATUS",
    key: "status",
    dataIndex: "status",
  },
];

export const transactionStatusOptions = [
  { field: "", value: "All" },
  { field: "transactionMode", value: TransactionType.USDC },
  { field: "transactionMode", value: TransactionType.USSD },
];

export const transactionSortOptions = [
  { order: SortOrder.DESC, field: "createdAt", key: "1" },
  { order: SortOrder.ASC, field: "createdAt", key: "0" },
];

export const initCustomerTransactionData: TTransactionData = {
  _id: "",
  amount: 0,
  createdAt: new Date(),
  customer: initCustomerData,
  description: "",
  device: initialDeviceData,
  distributor: "",
  flag: false,
  memo: "",
  netPay: 0,
  status: "successful",
  transactionFee: 0,
  transactionHash: null,
  transactionId: "",
  updatedAt: new Date(),
  activationDuration: 0,
  currency: {
    _id: "",
    code: "",
    country: "",
    flag: "",
    name: "",
    rate: 0,
    symbol: "",
  },
  earlyPayment: false,
  transactionMode: "usdc",
};

//paymentPlans page
//paymentPlans page
//paymentPlans page
export const paymentPlansColumns = [
  {
    title: "",
    dataIndex: "select",
    key: "select",
  },
  {
    title: "NAME",
    dataIndex: "planName",
    key: "planName",
  },
  {
    title: "FULL PAYMENT",
    dataIndex: "fullPaymentAmount",
    key: "fullPaymentAmount",
  },
  {
    title: "NO OF INSTALLMENTS",
    dataIndex: "installments",
    key: "installments",
  },
  {
    title: "DEVICES",
    key: "noOfDevices",
    dataIndex: "noOfDevices",
  },
];

export const paymentPlansStatusOptions = [
  { field: "", value: "All" },
  { field: "status", value: "purchased" },
  { field: "status", value: "available" },
];

export const paymentPlansSortOptions = [
  { order: SortOrder.DESC, field: "createdAt", key: "1" },
  { order: SortOrder.ASC, field: "createdAt", key: "0" },
];

//user Data
//user Data
//user Data

export const initUserData = {
  avatar: "",
  accountPlan: {
    _id: "",
    name: "",
    description: "",
    price: 0,
    currency: "",
    billingCycle: "",
    deviceLimit: "",
    transactionFeeRate: 0,
    isPopular: false,
    features: [],
    activationCreditLimit: 0,
  },
  accounts: [],
  createdAt: new Date(),
  deleted: false,
  currency: {
    _id: "",
    name: "",
    code: "",
    country: "",
    flag: "",
    rate: 0,
    symbol: "",
  },
  email: "",
  fullName: "",
  password: "",
  paymentId: "",
  phone: "",
  role: "",
  country: "",
  updatedAt: new Date(),
  __v: 0,
  _id: "",
  lastBilledDate: new Date(),
  nextBillDate: new Date(),
};

export const graphTimelineOptions = [
  { field: "daily", value: "daily" },
  { field: "monthly", value: "monthly" },
  { field: "yearly", value: "yearly" },
];

export const chartTimelineOptions = [
  { field: "This Week", value: "weekly" },
  { field: "This Month", value: "monthly" },
  { field: "This Year", value: "yearly" },
];

// activation credits page
// activation credits page
// activation credits page
export const activationCreditTableColumn = [
  {
    title: "SERIAL NUMBER",
    dataIndex: "serialNo",
    key: "serialNo",
  },
  {
    title: "DEVICE MODEL",
    dataIndex: "deviceModel",
    key: "deviceModel",
  },
  {
    title: "ACTIVATION DAYS",
    dataIndex: "noOfActivationDays",
    key: "noOfActivationDays",
  },
  {
    title: "ACTIVATION CODE",
    dataIndex: "activationCode",
    key: "activationCode",
  },
  {
    title: "STATUS",
    dataIndex: "activationCreditStatus",
    key: "status",
  },
  {
    title: "ACTION",
    key: "status",
    dataIndex: "activationCreditActions",
  },
];

export const activationCreditStatusOptions = [
  { field: "", value: "All" },
  { field: "status", value: ActivationCreditStatus.ACTIVE },
  { field: "status", value: ActivationCreditStatus.USED },
];

export const activationCreditSortOption = [
  { order: SortOrder.DESC, field: "createdAt", key: "1" },
  { order: SortOrder.ASC, field: "createdAt", key: "0" },
];

// billing page
// billing page
// billing page
export const billingPageTableColumn = [
  {
    title: "BILLING ID",
    dataIndex: "billId",
    key: "transaction_ID",
  },
  {
    title: "MONTH",
    dataIndex: "billMonth",
    key: "date",
  },
  {
    title: "AMOUNT",
    dataIndex: "billAmount",
    key: "amount",
  },
  {
    title: "STATUS",
    key: "status",
    dataIndex: "status",
  },
];
